import type { ChatContextUsage, ChatMessage, PersistedChatMessage } from "@/types/chat.type";

export function parseUsageFromSse(parsed: {
  inputTokens?: number;
  outputTokens?: number;
  contextTokens?: number;
  model?: string;
  inputCostUsd?: number;
  outputCostUsd?: number;
}): ChatContextUsage | null {
  if (typeof parsed.contextTokens !== "number") return null;
  return {
    inputTokens: typeof parsed.inputTokens === "number" ? parsed.inputTokens : 0,
    outputTokens: typeof parsed.outputTokens === "number" ? parsed.outputTokens : 0,
    contextTokens: parsed.contextTokens,
    ...(typeof parsed.model === "string" ? { model: parsed.model } : {}),
    ...(typeof parsed.inputCostUsd === "number" ? { inputCostUsd: parsed.inputCostUsd } : {}),
    ...(typeof parsed.outputCostUsd === "number" ? { outputCostUsd: parsed.outputCostUsd } : {}),
  };
}

export function mapPersistedChatMetadata(
  metadata: PersistedChatMessage["metadata"],
): ChatMessage["metadata"] {
  if (!metadata) return null;
  const out: Record<string, unknown> = {};
  if (metadata.thinking) out.thinking = metadata.thinking;
  if (metadata.usage) out.usage = metadata.usage;
  return Object.keys(out).length > 0 ? out : null;
}

export function buildAssistantMessageMetadata(
  thinking: { text: string; durationMs: number } | null,
  usage: ChatContextUsage | null,
): ChatMessage["metadata"] {
  const metadata: Record<string, unknown> = {};
  if (thinking?.text.trim()) metadata.thinking = thinking;
  if (usage) metadata.usage = usage;
  return Object.keys(metadata).length > 0 ? metadata : null;
}
